const authorityRoutes = [
  {
    path: "/userManagement",
    name: "userManagement",
    component: () => import("@/views/authority/userManagement.vue"),
    meta: {
      title: "用户管理",
      // keepAlive: true
    },
  },
  {
    path: "/roleList",
    name: "roleList",
    component: () => import("@/views/authority/roleList.vue"),
    meta: {
      title: "角色管理",
      // keepAlive: true
    },
  },
];

export default authorityRoutes;
